/* ==========================================================================
   WatchNoova — Lógica del botón WhatsApp y el pop-up de captura de correo
   Sin dependencias externas. Compatible con Dawn.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Utilidades de cookies ---------- */

  function wnSetCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax';
  }

  function wnGetCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  /* ---------- Botón de WhatsApp con burbuja ---------- */

  function wnInitWhatsAppBubble() {
    var wrapper = document.getElementById('wn-whatsapp-float');
    if (!wrapper) return;

    var bubble = document.getElementById('wn-wa-bubble');
    var closeBtn = document.getElementById('wn-wa-bubble-close');
    var delay = parseInt(wrapper.getAttribute('data-delay'), 10) || 4000;
    var dismissed = wnGetCookie('wn_wa_bubble_dismissed');

    if (!dismissed) {
      setTimeout(function () {
        bubble.classList.add('is-visible');
        bubble.removeAttribute('aria-hidden');
      }, delay);
    }

    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      bubble.classList.remove('is-visible');
      bubble.setAttribute('aria-hidden', 'true');
      wnSetCookie('wn_wa_bubble_dismissed', '1', 1);
    });
  }

  /* ---------- Pop-up de captura de correo ---------- */

  function wnInitEmailPopup() {
    var overlay = document.getElementById('wn-popup-overlay');
    if (!overlay) return;

    var COOKIE_NAME = 'wn_popup_seen';
    var COOKIE_DAYS = 7;
    var TRIGGER_DELAY = 60000; // siempre a los 60s en la página, desktop y mobile

    if (wnGetCookie(COOKIE_NAME)) return;

    var closeBtn = document.getElementById('wn-popup-close');
    var form = document.getElementById('wn-popup-form');
    var gate = document.getElementById('wn-popup-gate');
    var reveal = document.getElementById('wn-popup-reveal');
    var submitBtn = form ? form.querySelector('.wn-popup-submit') : null;

    var shown = false;

    function openPopup() {
      if (shown) return;
      shown = true;
      overlay.hidden = false;
      requestAnimationFrame(function () {
        overlay.classList.add('is-visible');
      });
      wnSetCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    }

    function closePopup() {
      overlay.classList.remove('is-visible');
      setTimeout(function () {
        overlay.hidden = true;
      }, 220);
    }

    setTimeout(openPopup, TRIGGER_DELAY);

    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup);
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closePopup();
    });

    // Envío del formulario sin recargar la página:
    // usamos un iframe oculto como destino para que Shopify procese
    // la creación del cliente en segundo plano, y mostramos la
    // confirmación de inmediato en la interfaz.
    if (form) {
      var iframe = document.createElement('iframe');
      iframe.name = 'wn-popup-target';
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      form.setAttribute('target', 'wn-popup-target');

      form.addEventListener('submit', function () {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Enviando…';
        }
        setTimeout(function () {
          gate.hidden = true;
          reveal.hidden = false;
        }, 500);
      });
    }
  }

  /* ---------- Pestañas de selección semanal ---------- */

  function wnInitWeeklyTabs() {
    var sections = document.querySelectorAll('.wn-weekly');
    sections.forEach(function (section) {
      var tabs = section.querySelectorAll('.wn-weekly__tab');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetId = tab.getAttribute('data-wn-tab');

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          section.querySelectorAll('.wn-weekly__panel').forEach(function (panel) {
            var isTarget = panel.id === targetId;
            panel.classList.toggle('is-active', isTarget);
            panel.hidden = !isTarget;
          });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    wnInitWhatsAppBubble();
    wnInitEmailPopup();
    wnInitWeeklyTabs();
  });
})();
